import React from 'react';
import {StreamBankLink} from "../../StreamBankLink";
import {service as SpeciesService} from "../../../../Services/SpeciesService";

export const SpeciesActivityTitle = props => {
    const {contextNodeActivity} = props;
    const {Activity: activity = null} = contextNodeActivity;
    const activityData = activity?.data;
    const species = activityData?.oldData ?? activityData?.newData;
    const speciesTitle = SpeciesService.GetFullTitle(species);
    const queryParams = species?.speciesId ? `?speciesId=${species.speciesId}` : '';
    const tool = (Number(activity?.activityTypeId) === 23) ? 'speciesRequests' : 'allSpecies';
    
    return <StreamBankLink Href={`/${tool}${queryParams}` }>{speciesTitle ?? "Species List Activity"}</StreamBankLink>;
};


